import React, { Component } from 'react';
import categoriesJS from '../json/categories.json';
import ReactHtmlParser from 'react-html-parser';

import canastaJS from '../json/canasta-basica.json';
import essJS from '../json/ess.json';
import spaJS from '../json/spa.json';
import entertaimentJs from '../json/entertaiment.json';
import rentaJs from '../json/renta.json';

class Categories extends Component {

    subItem = null;

    constructor(props) {
        super(props);
        this.state = { menu: null }
    }

    componentDidMount() {
        this.fillMenu(canastaJS);
    }

    showMenu = (categorieId, event) => {
        //Limpiamos el submenú
        if( this.subItem !== null ) {
            document.getElementById(this.subItem).classList.toggle('current');
            this.subItem = null;
        }

        document.getElementById(this.props.currentCategory).classList.toggle('current');
        document.getElementById(categorieId).classList.toggle('current');

        // Reiniciamos la lista de items
        this.props.udpateItemsList([]);
        this.props.updateCurrentCategory(categorieId);

        switch( categorieId ) {
            case 'canasta-basica': this.fillMenu(canastaJS);
                break;
            case 'spa': this.fillMenu(spaJS);
                break;
            case 'edu-salud': this.fillMenu(essJS);
                break;
            case 'entretenimiento': this.props.initItemList(entertaimentJs);
                this.props.udpateItemsList(entertaimentJs);
                if(this.state.menu !== null) { this.setState({ menu: null }); }
                break;
            case 'renta': this.props.initItemList(rentaJs);
                this.props.udpateItemsList(rentaJs);
                if(this.state.menu !== null) { this.setState({ menu: null }); }
                break;
            default: if(this.state.menu !== null) { this.setState({ menu: null }); }
                break;
        }
    }

    fillMenu(items) {
        document.getElementById('sub-categorie-menu').scrollTop = 0;
        var menu = <ul className="list-group">
                { items.map( (item, idx) => <li id={`menu-item-${item.category}-${idx}`} key={`menu-item-${item.item}-${idx}`} className="list-group-item" onClick={(e) => this.displayItems(item, `menu-item-${item.category}-${idx}`, e)}>{ item.category }</li> ) }
            </ul>;
        this.setState({ menu });
    }

    displayItems(item, id, e) {
        // Current value
        if( this.subItem !== null ) { document.getElementById(this.subItem).classList.toggle('current'); }
        document.getElementById(id).classList.toggle('current');
        this.subItem = id;

        this.props.initItemList(item);
        this.props.udpateItemsList(item);
    }


    render() {
        return <div id="categorie-menu" className="categorias">
            <p>Seleccione una categoría:</p>
            <ul className="list">
                {categoriesJS.map((categorie, idx) =>
                    <li id={categorie.id} key={`categorie-item-${idx}`} className={(idx === 0) ? 'current' : ''} onClick={(e) => this.showMenu(categorie.id, e)}>
                        <span className="icon"><img src={categorie.icon} alt={ReactHtmlParser(categorie.name)} /></span>
                        <span className={`tab`}>{ReactHtmlParser(categorie.name)}</span>
                    </li>
                )}
            </ul>
            <div id="sub-categorie-menu" className="subcategorias form-group">
                {this.state.menu}
            </div>
        </div>
    }

}

export default Categories;